import React from 'react';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { default as Loader } from '../Loader/';
import {
  CONTRACTUAL_CATEGORIES,
  CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
} from '../CarQuote/constants';

import messages from './messages';

import { Row, Col, Alert, Divider, Form, Button } from 'antd';
import 'antComponentsStyle';

import reducer from './reducer';
import saga from './saga';
import { setUpdated } from './actions';
import { makeSelectLoading, selectHasErrors, selectUpdated } from './selectors';

class ConfirmForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      proposal: props.proposal,
      errors: {
        phone: false,
        zip_code: false
      }
    };
  }

  componentDidUpdate() {
    if (this.props.isUpdated) {
      this.props.onNext();
      this.props.resetUpdated();
    }
  }

  handelSubmit = e => {
    e.preventDefault();

    this.props.onNext();
  };

  get quotationExists() {
    return this.props.proposal.quotation && this.props.proposal.quotation.data && this.props.proposal.quotation.data.code !== undefined;
  }

  get isBusinessEmployee() {
    const { employee_category } = this.props.proposal.customer;

    if (employee_category !== undefined) {
      const selectedContractualCategory = CONTRACTUAL_CATEGORIES.filter(category => category.value === employee_category);
      return selectedContractualCategory[0] && selectedContractualCategory[0].type === CONTRACTUAL_CATEGORIES_TYPE_BUSINESS;
    }

    return false;
  }

  render() {
    const { hasErrors, proposal, loading, onPrev } = this.props;
    const { customer, offer: {data: offer} } = proposal;

    return (
      <Form layout="vertical" className="position-relative">
        {loading &&
          <Loader loading={true} />
        }
        {!this.quotationExists &&
        <div id="TopBanner" className="element-box">
          <FormattedMessage {...messages.formConfirmDescription} />
        </div>
        }
        {hasErrors && (
          <Alert
            type="error"
            isOpen={hasErrors}
            closable
            className="mt-2"
            message={<FormattedMessage {...messages.serverError} />}
          />
        )}
        <Row gutter={16} className="mt-4">
          <Col md={12}>
            <Form.Item
              label={<FormattedMessage {...messages.fiscalCode} />}
            >
              <>{customer.fiscal_code}</>
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item
              label={<FormattedMessage {...messages.contractualsCategories} />}
            >
              <>{customer.category.description}</>
            </Form.Item>
          </Col>
        </Row>
        {this.isBusinessEmployee && (
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item
                label={<FormattedMessage {...messages.vatNumber} />}
              >
                <>{customer.vat_number}</>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                label={<FormattedMessage {...messages.businessName} />}
              >
                <>{customer.business_name}</>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                label={<FormattedMessage {...messages.pec} />}
              >
                <>{customer.pec}</>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                label={<FormattedMessage {...messages.sdi_code} />}
              >
                <>{customer.sdi_code}</>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row gutter={16}>
            <Col md={12}>
              <Form.Item
                label={<FormattedMessage {...messages.firstName} />}
              >
                <>{customer.first_name}</>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                label={<FormattedMessage {...messages.lastName} />}
              >
                <>{customer.last_name}</>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Email">
                <>{customer.email}</>
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Telefono">
                <>{customer.phone}</>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Indirizzo">
                <>{customer.address}</>
              </Form.Item>
            </Col>
            <Col md={3}>
              <Form.Item
                label={<FormattedMessage {...messages.zipCode} />}
              >
                <>{customer.zip_code}</>
              </Form.Item>
            </Col>
            <Col md={9}>
              <Form.Item
                label={<FormattedMessage {...messages.city} />}
              >
                <>{customer.city}</>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Note preventivo">
                <>{proposal.notes}</>
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Row gutter={16}>
            <Col md={12}>
              {!this.quotationExists &&
              <Form.Item>
                <Button
                  size="large"
                  onClick={onPrev}
                  icon="arrow-left"
                  type="link"
                >
                  <FormattedMessage {...messages.back} />
                </Button>
              </Form.Item>
              }
            </Col>
            <Col md={12}>
              <Form.Item className="text-right">
                <Button
                  size="large"
                  className="btn-primary"
                  type="primary"
                  onClick={this.handelSubmit}
                  disabled={loading || !proposal.stillValid}
                >
                  <FormattedMessage {...messages.ahead} />
                </Button>
              </Form.Item>
            </Col>
          </Row>
      </Form>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  hasErrors: selectHasErrors(),
  isUpdated: selectUpdated(),
});

export function mapDispatchToProps(dispatch) {
  return {
    resetUpdated: () => dispatch(setUpdated(false)),
  };
}

const withReducer = injectReducer({ key: 'quote', reducer });
const withSaga = injectSaga({ key: 'quote', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(ConfirmForm);
